import type { PageContext } from '@teo/widget-shared';
import { getCartSnapshot } from './cart-state.js';

/** Attach live cart snapshot to page context when available. */
export function mergeCartIntoContext(context: PageContext): PageContext {
  const cart = getCartSnapshot();
  if (!cart) return context;

  return {
    ...context,
    cart,
    sources: context.sources.includes('cart')
      ? context.sources
      : [...context.sources, 'cart'],
  };
}
